import script from "./account-table-header-badge.vue?vue&type=script&setup=true&lang=ts"
export * from "./account-table-header-badge.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__